let isAuthChecking = false;

/**
 * Indica si el guard del router esta verificando autenticacion.
 * @returns valor actual del flag
 */
export function getIsAuthChecking(): boolean {
  return isAuthChecking;
}

/**
 * Activa o desactiva la supresion de redirect en el interceptor 401.
 * Se usa desde el guard del router para evitar navegaciones en conflicto.
 * @param value - true para suprimir redirect, false para permitirlo
 */
export function setAuthChecking(value: boolean) {
  isAuthChecking = value;
}
